module.exports = __webpack_public_path__ + "img/Autoayuda.941b9b1d.svg";